var map = {
	"./tianlian/header.png": "R7zz",
	"./zhangmen/header.png": "tsAA",
	"./zhetian/header.png": "1UBo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i53U";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*\/header\.png$
// module id = i53U
// module chunks = 5